// src/api/employee.ts
import { apiClient } from "../helpers/api_helper";

export interface Employee {
  id: number;
  name: string; // Changed from first_name + last_name to single name
  employee_code?: string;
  date_of_birth?: string;
  aadharr?: string;
  gender?: string;
  phone?: string; // Removed email
  personal_email?:string
  official_email?:string
  date_of_joining?: string;
  address?: string;
  city?: string;
  state?: string;
  bank_id?: number;
  pincode?: string;
  bank_name?: string;
  bank_account_no?: string;
  ifsc_code?: string;
  geofence: boolean;
  facedetection?: boolean;
  bank_branch?: string;
  basic_salary?: number;
  take_home_salary?: string;
  site_allowance?: string;
  pf_esi_applicable?: number;
  pf_esi_gross_salary?: number;
  pf_number?: string;
  esi_number?: string;
  paid_leaves?: number;
  payment_mode?: number;
  salary_calculation?: number;
  overtime?: boolean;
  designation_id?: number;
  designation?: {
    id: number;
    title: string;
    // Add other designation fields if needed
  };
  // Removed: department
  date_of_exit?: string;
  status: number; // 1=active, 0=inactive, 2=resigned, 3=terminated
  unit_id?: number;
  unit?: {
    id: number;
    name: string;
    // Add other unit fields if needed
  };
  created_at: string;
  updated_at: string;
}

export interface EmployeeFilters {
  page?: number;
  limit?: number;
  search?: string;
  name?: string;
  designation_id?: number;
  unit_id?: number;
  status?: number;
  payment_mode?: string;
  salary_calculation?: string;
  department?: string;
  gender?: string;
  min_basic_salary?: number;
  max_basic_salary?: number;
  min_gross_salary?: number;
  max_gross_salary?: number;
  date_of_joining_from?: string;
  date_of_joining_to?: string;
  sort_by?: string;
  sort_order?: "asc" | "desc";
}

export interface EmployeeStatusUpdate {
  status: "active" | "inactive" | "resigned" | "terminated";
  date_of_exit?: string;
  termination_reason?: string;
}

export const fetchEmployees = async (filters?: EmployeeFilters) => {
  const queryParams = new URLSearchParams();

  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });
  }

  const response = await apiClient.get(`/employees?${queryParams.toString()}`);
  console.log("API Response:", response); // Debugging line
  return response;
};

export const fetchEmployeeById = async (id: number) => {
  const response = await apiClient.get(`/employees/${id}`);
  return response.data;
};

export const updateEmployee = async (id: number, data: Partial<Employee>) => {
  const response = await apiClient.patch(`/employees/${id}`, data);
  return response.data;
};

export const updateEmployeeStatus = async (
  id: number,
  data: EmployeeStatusUpdate,
) => {
  const response = await apiClient.patch(`/employees/${id}/status`, data);
  return response.data;
};

export const bulkUpdateEmployeeStatus = async (
  ids: number[],
  status: string,
) => {
  const response = await apiClient.patch(`/employees/bulk/status`, {
    ids,
    status,
  });
  return response.data;
};

export const fetchPaymentModes = async () => {
  const response = await apiClient.get("/employees/payment-modes");
  return response.data;
};

export const fetchSalaryCalculations = async () => {
  const response = await apiClient.get("/employees/salary-calculations");
  return response.data;
};

export const uploadEmployeeExcel = async (formData: FormData) => {
  const response = await apiClient.post("/employees/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.data;
};

export const pullUsersFromDevice = async () => {
  try {
    // Get device IP from environment
    const deviceIp = process.env.REACT_APP_DEVICE_IP || "192.168.29.127";
    const devicePort = process.env.REACT_APP_DEVICE_PORT || "8081";
    const token = process.env.REACT_APP_DEVICE_TOKEN || "MY_SECRET_TOKEN_2026";

    const url = `http://${deviceIp}:${devicePort}/api/pull-users?token=${token}`;

    const response = await apiClient.get(url);
    return response.data;
  } catch (error: any) {
    console.error("Error pulling users from device:", error);
    throw error;
  }
};
